export default "__VITE_ASSET__D_7on52W__"